import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RankingComponent } from './views/ranking/ranking.component';

const routes: Routes = [
	{ path: 'ranking', component: RankingComponent, },

	// 404:
	{ path: '**', redirectTo: '' },

];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// /app/src/app/app-routing.module.ts